import { useMapRasterLayer } from "./useMapRasterLayer"
import { useReportOverlayStatus } from "./useReportOverlayStatus"
import { BASEMAP_RASTER_LAYER_IDS, overlaysBelow } from "./layerOrder"

// GIBS WMTS: ASTER Global Digital Elevation Model (GDEM) colorized by elevation index.
// Rainbow palette: blue (low) → green → yellow → orange → red (high). Static 30m dataset.
// Level12 tile matrix set provides finer detail at higher zoom levels.
export const GIBS_ASTER_GDEM =
    "https://gibs.earthdata.nasa.gov/wmts/epsg3857/best/ASTER_GDEM_Color_Index/default/GoogleMapsCompatible_Level12/{z}/{y}/{x}.jpg"

const ABOVE = [...BASEMAP_RASTER_LAYER_IDS, ...overlaysBelow("elevation")]

export function useElevationLayer(enabled: boolean) {
    const status = useMapRasterLayer(enabled, "elevation", GIBS_ASTER_GDEM, {
        maxzoom: 12,
        opacity: 0.5,
        saturation: -0.2,
        persistSource: true,
        above: ABOVE,
    })
    useReportOverlayStatus("elevation", status)
}
